"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.escapeRegex = void 0;
// https://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
var escapeRegex = function escapeRegex(str) {
  return str.replace(/[\\^$.*+?()[\]{}|]/g, '\\$&');
};
exports.escapeRegex = escapeRegex;